import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ngxLoadingAnimationTypes } from 'ngx-loading';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  public loadingConfig = {
    animationType: ngxLoadingAnimationTypes.cubeGrid,
    primaryColour: '#FFFFFF',           // White color for cube animation for high contrast
    secondaryColour: '#687870',         // Muted gray-green for secondary color
    backdropBackgroundColour: 'rgba(0,0,0,0.5)', // Darker, semi-transparent backdrop
    backdropBorderRadius: '8px',        // Rounded edges for a softer look
    fullScreenBackdrop: true,           // Full-screen loader
  };
  show(): void {
    this.loadingSubject.next(true);
  }

  hide(): void {
    this.loadingSubject.next(false);
  }
}
